import { memo } from "react";

import { Close, Success as SuccessIcon } from "../../icons";
import "../../styles/_message.scss";

export const Success = memo(({ closePopup }: { closePopup: () => void }) => (
  <div className="accept-button-message-71d72f0d-8486-4d9d-b58c-a5b9facf4701">
    <div className="message__main">
      <button
        type="button"
        className="message__close"
        onClick={() => closePopup()}
      >
        <Close />
      </button>
      <div className="message__icon">
        <SuccessIcon />
      </div>
      <h2 className="message__title">Accepted</h2>
      <p className="message__text">
        Congratulations, the offer has been accepted!
      </p>
      <button
        type="button"
        className="message__action"
        onClick={() => closePopup()}
      >
        Done
      </button>
    </div>
  </div>
));
